import { ApiManager } from "../index";
import { isBBShopMerchant } from "./merchantHelpers";

const api = ApiManager.getInstance();

export function flattenMerchantCategories(categories = []) {
  const result = [];

  const walk = (items) => {
    items.forEach((item) => {
      result.push(item);
      const children = item.sub_categories || item.children || [];
      if (children.length) {
        walk(children);
      }
    });
  };

  walk(categories);
  return result;
}

export async function fetchMerchantCategories(user) {
  const token = user?.token;
  if (!token) {
    return [];
  }

  const categoryApi = isBBShopMerchant(user)
    ? api.product.categories
    : api.product.merchantCategories;

  const res = await categoryApi.run({ token });
  if (!res.result) {
    return [];
  }

  let list = [];
  if (isBBShopMerchant(user)) {
    list = res.data?.merchant_categories || [];
  } else if (Array.isArray(res.data?.data)) {
    list = res.data.data;
  } else if (Array.isArray(res.data)) {
    list = res.data;
  }

  return flattenMerchantCategories(list);
}
